const contractorTypes = [
  { label: "All Contractors", value: "All Contractors" },
  { label: "Electrician", value: "Electrician" },
  { label: "Plumbing", value: "Plumbing" },
  { label: "Heating & Cooling", value: "Heating & Cooling" },
  { label: "Roofing", value: "Roofing" },
  { label: "Remodeling", value: "Remodeling" },
  { label: "Handyman", value: "Handyman" },
  { label: "Landscaping", value: "Landscaping" },
  { label: "Flooring", value: "Flooring" },
  { label: "Painting", value: "Painting" },
  { label: "Carpentry", value: "Carpentry" },
  { label: "Drywall", value: "Drywall" },
  { label: "Concrete", value: "Concrete" },
  { label: "Fencing", value: "Fencing" },
  { label: "Insulation", value: "Insulation" },
  { label: "Garage Doors", value: "Garage Doors" },
  { label: "Doors & Windows", value: "Doors & Windows" },
  { label: "Siding", value: "Siding" },
  { label: "Deck & Patio", value: "Deck & Patio" },
  { label: "Home Cleaning", value: "Home Cleaning" },
  { label: "Power Washing", value: "Power Washing" },
  { label: "Leaks & Water Damage", value: "Leaks & Water Damage" },
  { label: "Structural Issues", value: "Structural Issues" },
  { label: "Gutter", value: "Gutter" },
  { label: "Pest Control", value: "Pest Control" },
  { label: "Home Security", value: "Home Security" },
  { label: "Fire Protection", value: "Fire Protection" },
  { label: "Home Automation", value: "Home Automation" },
  { label: "Irrigation", value: "Irrigation" },
  { label: "Appliance Repair", value: "Appliance Repair" },
  { label: "General Contractor", value: "General Contractor" },
  { label: "Home Building", value: "Home Building" },
  { label: "Architect", value: "Architect" },
  { label: "Home Inspection", value: "Home Inspection" },
  { label: "Snow Removal", value: "Snow Removal" },
  { label: "Moving Services", value: "Moving Services" }
];

export default contractorTypes;